import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormControl} from '@angular/forms';
import * as moment from "moment";
import {AutomationAction} from "../../../../util/automations";
import Swal from "sweetalert2";
import {AutomationProvider} from "../../../../providers/automation/automation";
import {Snackbar} from "../../../../util/snackbar";

@Component({
  selector: 'app-execucao-automacoes',
  templateUrl: './execucao-automacoes.component.html',
  styleUrls: ['./execucao-automacoes.component.scss']
})
export class ExecucaoAutomacoesComponent implements OnInit {

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    public snackBar: Snackbar,
    public automationProvider: AutomationProvider
  ) {
  }

  public loading: boolean = false;
  @Input() public existingAutomationInfo;
  @ViewChild('grid', {static: false}) grid = null;
  public automationData = null;
  public dataSourceMain: any[] = [];
  public filteredDataSource: any[] = [];
  public filterControl = new FormControl('');


  ngOnInit() {
    this.getData();
    this.setupFilter();
  }

  setupFilter(): void {
    this.filterControl.valueChanges.subscribe(value => {
      this.applyFilter(value || '');
    });
  }

  applyFilter(filterValue: string): void {
    const filter = filterValue.toLowerCase().trim();
    if (!filter) {
      this.filteredDataSource = [...this.dataSourceMain];
    } else {
      this.filteredDataSource = this.dataSourceMain.filter(automation =>
        automation.companyId.toString().includes(filter) ||
        automation.description.toLowerCase().includes(filter)
      );
    }
  }

  getData() {
    this.loading = true;
    this.automationProvider.getAutomationInfoForExecution(this.existingAutomationInfo.groupId, this.existingAutomationInfo.service)
      .then((result) => {
        this.automationData = result;
        this.mapDataForGrid();
      })
      .catch((error) => {
        this.snackBar.openLong(error.message, 'erro');
      }).finally(() => {
      this.loading = false;
    });
  }

  mapDataForGrid() {
    const data = [...this.automationData];
    this.dataSourceMain = [];
    if (data) {
      data.forEach(item => {
        this.dataSourceMain.push({
          id: item[0],
          companyId: item[1],
          description: item[2],
          action: AutomationAction[item[3]],
          isActive: item[4],
          status: item[5],
          lastExecution: item[6] ? moment(item[6]).format('DD/MM/YYYY HH:mm:ss') : null,
        });
      });
      this.filteredDataSource = [...this.dataSourceMain];
      this.applyFilter(this.filterControl.value || '');
      if (this.grid) this.grid.refresh();
    } else {
      console.warn('No existing automation info provided or data is missing.');
    }
  }

  fireExecutionSwal(automation) {
    Swal.fire({
      title: 'Atenção',
      html:
        'Esta ação solicita execução imediata da automação <b>' + automation.description + '</b> na empresa <b>' + automation.companyId + '</b>.<br><br>' +
        (automation.lastExecution ? 'A última execução dessa automação foi em <b>' + automation.lastExecution + '</b>' : 'Essa automação nunca foi executada antes.') +
        '<br><br> <b>Você tem certeza que deseja continuar?<b/>',
      icon: 'warning',
      reverseButtons: true,
      confirmButtonColor: '#f05050',
      confirmButtonText: 'Sim, desejo continuar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#3085d6'
    }).then((result) => {
      if (result.isConfirmed) {
        this.requestAutomationExecution(automation);
      }
    });
  }

  requestAutomationExecution(automation) {
    this.loading = true;
    this.automationProvider.requestAutomationExecution(automation.id, this.existingAutomationInfo.service).then((result) => {
      setTimeout(() => {
        this.snackBar.open('Solicitação de execução enviada com sucesso!', 'success');
        this.loading = false;
        this.getData();
      }, 5000);
    }).catch((error) => {
      this.snackBar.open(`${error.error.error_description}`, 'erro');
      this.loading = false;
    })
  }
}